// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"c6a5b0a4","199":"f1bfe67d","331":"30c28802","565":"666bab49","995":"c26f83d2"}[chunkId] + ".chunk.js";
};